import React from 'react';
import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const PageLoader = ({loading}) => {
  return (
    <Flex align="center" gap="middle">
      <Spin tip="Loading..." spinning={loading} fullscreen indicator={<LoadingOutlined style={{color:"white"}} spin />} size="large" />
    </Flex>
  );
};
export default PageLoader;